import { Button } from 'components/button/Button';
import DOMPurify from 'dompurify';
import { Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal } from 'reducers/modal';
import { setInstructionsUnderstood } from 'reducers/abilityTests';
import { startAT } from '../AbilityTestApi';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';
import { selectAssessmentName } from 'reducers/assessment';
import { isMobileOnly } from 'react-device-detect';

type ModalProps = {
  data: {
    title: string;
    info: string;
    prongID: number;
  };
};

export const AbilityTestsBeforeYouBeginModal: React.FC<ModalProps> = ({
  data,
}) => {
  const [generalError, setGeneralError] = useState<string>();

  const dispatch = useDispatch();
  const { t } = useTranslation('Candidate+Journey+-+PQTest', { i18n });
  const assessmentName = useSelector(selectAssessmentName);

  useEffect(() => {
    dispatch(setInstructionsUnderstood(false));
  }, []);

  useEffect(() => {
    const understandBtn: any = document.getElementsByClassName("UnderstandBtn")[0];
    understandBtn.focus();
  }, []);  

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleStartPQ = () => {
    (async () => {
      const result = await startAT({ assessmentProngID: data.prongID });

      if (result.response) {
        window.focus();
        setGeneralError('');
        dispatch(setInstructionsUnderstood(true));
      } else {
        setGeneralError(t('pPQInstruction_General_Error'));
      }
    })();
  };

  const modalStyle = {
    '--modalTitleColor': '#036C8F',
    '--footerBackgroundColor': '#f5f5f5',
    '--footerBorderColor': '#f5f5f5',
    '--primaryButtonBackgroundColor': '#731447',
    '--tertiaryButtonBackgroundColor': '#d5d5d5',
  } as React.CSSProperties;

  const currentWebskin = window.sessionStorage.getItem('webskin')
    ? window.sessionStorage.getItem('webskin')
    : 'defaultTheme';

  return (
    <div
      className={
        `AbilityTestsBeforeYouBeginModal ${isMobileOnly ? 'Mobile' : ''}` +
        (assessmentName ? ' ' + assessmentName : '') +
        (currentWebskin !== 'defaultTheme' ? ' ' + currentWebskin : '')
      }
      style={modalStyle}
    >
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <div className="AbilityTestsBeforeYouBeginModal__content AbilityTestsModalContent">
            <div className="AbilityTestsBeforeYouBeginModal__message">
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(data.info),
                }}
              />
            </div>
          </div>
          <div className="ModalFooter">
            {generalError && <div className="GeneralError">{generalError}</div>}
            <Button
              className="Rounded"
              priority="tertiary"
              type="button"
              onClick={handleCloseModal}
            >
              {t('SSCandidate_Candidate_Journey_PQTest_Cancel')}
            </Button>
            <Button
              className="Discard Rounded UnderstandBtn"
              priority="primary"
              type="submit"
              onClick={handleStartPQ}
            >
              {t('SSCandidate_Candidate_Journey_PQTest_I_Understand')}
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};
